import { faCheck } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@pickleballinc/react-ui';
import { forwardRef } from 'react';

import { MobileFilterRow } from '@/modules/rankings/MobileFilter/MobileFilterRow';
import { PlayerFiltersInterface } from '@/types/ranking.types';

interface StateMobileProps {
  week?: {
    id: string;
    title: string;
  };
  weekDropdownOpen: boolean;
  toggleWeekDropdown: () => void;
  weekDropdownRef: React.RefObject<HTMLDivElement | null>;
  weeksList: Array<{ id: string; title: string }>;
  filters: PlayerFiltersInterface;
  setFilters: React.Dispatch<React.SetStateAction<PlayerFiltersInterface>>;
  handleClickCancel: () => void;
  handleClickNext: () => void;
}

const WeekMobile = forwardRef<HTMLDivElement, StateMobileProps>(
  (
    {
      week,
      weekDropdownOpen,
      toggleWeekDropdown,
      weekDropdownRef,
      weeksList,
      filters,
      setFilters,
      handleClickCancel,
      handleClickNext,
    },
    ref
  ) => {
    return (
      <div ref={ref}>
        {!weekDropdownOpen ? (
          <MobileFilterRow
            label='Week'
            value={week?.title}
            onClick={toggleWeekDropdown}
            testId='rankings-week-button'
          />
        ) : (
          <div
            className='mx-auto w-full max-w-md rounded-lg border border-gray-200 bg-white p-4 shadow-md'
            ref={weekDropdownRef}
          >
            <h2 className='mb-4 text-lg font-semibold' onClick={toggleWeekDropdown}>
              Week
            </h2>

            <div className='mb-4 max-h-[45vh] space-y-2 overflow-y-auto rounded-md border border-gray-200'>
              {weeksList.map((option) => {
                return (
                  <div
                    key={String(option.id)}
                    onClick={() => setFilters({ ...filters, week: String(option.id) })}
                    className={`m-1 flex cursor-pointer justify-between rounded-lg p-3 text-gray-900 ${
                      filters.week === String(option.id) ? 'bg-gray-50' : 'bg-white'
                    }`}
                    data-testid={`rankings-week-option-${option.title}`}
                  >
                    {option.title}
                    {filters.week === String(option.id) && (
                      <span className='ml-2 text-purple-600'>
                        <FontAwesomeIcon icon={faCheck} />
                      </span>
                    )}
                  </div>
                );
              })}
            </div>

            <div className='flex justify-between gap-2'>
              <Button
                className='flex w-[150px] items-center justify-center rounded-lg border border-gray-300 px-4 py-2 text-gray-700 hover:bg-gray-100'
                onClick={handleClickCancel}
                variant='secondary'
                data-testid='rankings-week-button-cancel'
              >
                Cancel
              </Button>
              <Button
                className='flex w-[150px] items-center justify-center rounded-lg bg-purple-600 px-4 py-2 text-white hover:bg-purple-700'
                onClick={handleClickNext}
                variant='primary'
                data-testid='rankings-week-button-next'
              >
                Next
              </Button>
            </div>
          </div>
        )}
      </div>
    );
  }
);

// Add display name for better debugging
WeekMobile.displayName = 'WeekMobile';

export default WeekMobile;
